export default "/images/vendor/flag-icons/flags/1x1/bj.svg?c1bc198cb05444a63756c251d8052e62";